export default "__VITE_ASSET__49w$63Ra__"